export var componentsLocales = {
    cabinetSettings: 'Личный кабинет Контура',
    cabinetCertificates: 'Сертификаты',
    cabinetServices: 'Оплата сервисов',
    logout: 'Выйти',
};
